import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { validationMixin } from 'vuelidate'
import { RuleDecl } from 'vue/types/options'
import { getValidator } from './validators'
import Form from '@/mixins/form'
import Validator from '@/mixins/form/validator'
import * as assert from 'deep-assert'

@Component
export default class Input extends mixins(validationMixin) {
  @Model('input', { type: [String, Number, Boolean] }) value!:
    | string
    | number
    | boolean
  @Prop(String) name!: string
  @Prop({ default: '', type: String }) displayName!: string
  @Prop({ default: () => ({}) }) rules!: { [key: string]: any }

  @Watch('rules')
  onChangeRules(newValue: any, oldValue: any) {
    try {
      assert.deepEquals(newValue, oldValue)
    } catch (e) {
      this.init()
    }
  }

  // form mixinから自動的に取得する
  notify = false

  castFunction?: ((newValue: any) => any) | null = null

  supportedRules: Array<string> = []

  get innerValue() {
    return this.value
  }

  set innerValue(newValue) {
    if (this.castFunction) {
      newValue = this.castFunction(newValue)
    }

    if (newValue !== this.value) {
      this.$v.$touch()
      this.$emit('input', newValue)

      if (this.notify) {
        ;(this.$parent as Form).validator.handleValidate()
      }
    }
  }

  created() {
    this.init()
  }

  init() {
    const parent = this.$parent as Form

    if (parent.validator instanceof Validator === false) {
      throw new Error(
        'Cannot use a component related to Input from a instance not extending Form mixin.'
      )
    }

    if (
      Object.keys(this.rules).some(
        key => (this.supportedRules as Array<string>).indexOf(key) === -1
      )
    ) {
      throw new Error('Not supported rule name is found in Input#created')
    }

    Vue.set(parent.validator.evaluators, this.name, this.$v.innerValue)
    Vue.set(parent.validator.errors, this.name, false)
    Vue.set(parent.validator.displayNames, this.name, this.displayName)

    this.notify = parent.isValidationNotify
  }

  beforeDestroy() {
    const parent = this.$parent as Form
    Vue.delete(parent.validator.evaluators, this.name)
    Vue.delete(parent.validator.errors, this.name)
    Vue.delete(parent.validator.displayNames, this.name)
  }

  validations() {
    const rules = this.rules
    const supportedRules = this.supportedRules

    const ruleSet = supportedRules.reduce((ruleSet, ruleName) => {
      if (ruleName in rules === false) {
        return ruleSet
      }

      const params = rules![ruleName]

      return Object.assign(ruleSet, {
        [ruleName]: getValidator(
          ruleName,
          params,
          (this.$parent as Form).validator.evaluators
        )
      })
    }, {} as RuleDecl)

    return {
      innerValue: ruleSet
    }
  }
}
